import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar({ userId, username, gu, onLogout }) {

  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;

  const resetForm = () => {
    setPw('');
    setPw2('');
  };

  const closeModal = () => {
    resetForm();
    setOpen(false);
  };

  const savePassword = async () => {

    if (!pw) {
      alert('신규 비밀번호를 입력 해주세요.');
      return;
    }

    if (pw !== pw2) {
      alert('비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      const apiPath =
        gu === "1" ? 'change-password2'
        : gu === "2" ? 'change-password'
        : 'change-password';   // 기본값 필요하면

      const res = await fetch(`${serverUrl}/api/${apiPath}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: userId,
          newPassword: pw
        })
      });

      const text = await res.text();   // 🔴 JSON 말고 TEXT

      console.log('서버 응답:', text);

      if (text === 'SUCCESS') {
        alert('비밀번호가 정상적으로 변경되었습니다.');
        closeModal();
      } else {
        alert(text);   // 🔴 MSSQL 메시지 그대로
      }

    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <>
      <div className="nav-wrap">
        <Link to="/Dashboard" className="nav-home">IZEN Implant</Link>

        <div className="nav-login">
          {username && (
            <span className="nav-user-info">
              {userId} ({username})
            </span>
          )}

          <button className="mypage-button" onClick={() => setOpen(true)}>
            마이페이지
          </button>

          <button onClick={onLogout} className="logout-button">
            로그아웃
          </button>
        </div>
      </div>

      {open && (
  <div className="mypage-overlay">
    <div className="mypage-modal">

      <div className="mypage-header">
        <h3>마이페이지</h3>
        <div className="btn-wrap">
          <button className="save-btn" onClick={savePassword}>저장</button>
          <button className="close-btn" onClick={closeModal}>닫기</button>
        </div>
      </div>

      <div className="mypage-form">
        <div className="row">
          {gu === "1" && (<label>기공사ID</label>)}
          {gu === "2" && (<label>회사ID</label>)}
          <input value={userId} readOnly />
        </div>

        <div className="row">
          {gu === "1" && (<label>기공사명</label>)}
          {gu === "2" && (<label>회사명</label>)}
          <input value={username} readOnly />
        </div>

        <div className="row">
          <label>신규 비밀번호</label>
          <input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
          />
        </div>

        <div className="row">
          <label>비밀번호 확인</label>
          <input
            type="password"
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
          />
        </div>
      </div>

    </div>
  </div>
)}

    </>
  );
}

export default Navbar;
